const CircleStatusIcon = ({ status }) => {
  const greenCircleIcon = (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="20" cy="20" r="20" fill="#00B29F" />
      <g clip-path="url(#clip0_1818_4625)">
        <path
          d="M15.7988 27.4791L7.9385 18.8333C7.70695 18.588 7.73132 18.1956 7.97505 17.9626L9.77865 16.307C10.0224 16.074 10.4123 16.0985 10.6439 16.3438L16.664 22.9661L29.5694 11.2667C29.8254 11.046 30.2031 11.0582 30.4347 11.3157L32.0677 13.143C32.287 13.4006 32.2748 13.7807 32.0189 14.0137L17.0783 27.5405C16.7127 27.8838 16.14 27.847 15.7988 27.4791Z"
          fill="white"
          fill-opacity="0.87"
        />
      </g>
      <defs>
        <clipPath id="clip0_1818_4625">
          <rect
            width="26.6667"
            height="26.6667"
            fill="white"
            transform="translate(6.66667 6.66667)"
          />
        </clipPath>
      </defs>
    </svg>
  );

  const redCircleIcon = (
    <svg
      width="40"
      height="40"
      viewBox="0 0 52 52"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M51.2 25.6C51.2 39.7385 39.7385 51.2 25.6 51.2C11.4615 51.2 0 39.7385 0 25.6C0 11.4615 11.4615 0 25.6 0C39.7385 0 51.2 11.4615 51.2 25.6Z"
        fill="#EB0A37"
      />
      <path
        d="M23.9571 37.3375H27.3491C27.4558 37.3375 27.5518 37.2948 27.6265 37.2202C27.7011 37.1455 27.7438 37.0495 27.7438 36.9428V33.4655C27.7438 33.3588 27.7011 33.2628 27.6265 33.1882C27.5518 33.1135 27.4558 33.0708 27.3491 33.0708H23.8718C23.7651 33.0708 23.6691 33.1135 23.5944 33.1882C23.5198 33.2628 23.4771 33.3588 23.4771 33.4655V36.8468C23.4771 36.9748 23.5305 37.0922 23.6158 37.1882C23.7011 37.2735 23.8291 37.3268 23.9571 37.3375Z"
        fill="white"
        fillOpacity="0.87"
      />
      <path
        d="M24.2134 29.5404C24.224 29.6364 24.2667 29.7218 24.3414 29.7751C24.416 29.8391 24.5014 29.8711 24.5974 29.8711H26.6454C26.7414 29.8711 26.8374 29.8391 26.9014 29.7751C26.976 29.7111 27.0187 29.6258 27.0294 29.5404L27.7334 23.2258V14.2444C27.7334 14.1911 27.7227 14.1378 27.7014 14.0844C27.68 14.0311 27.648 13.9884 27.6054 13.9564C27.5627 13.9244 27.5094 13.8924 27.456 13.8818C27.4027 13.8711 27.3387 13.8604 27.2854 13.8711H23.8614C23.808 13.8711 23.7654 13.8818 23.712 13.8924C23.6587 13.9031 23.6267 13.9351 23.584 13.9671C23.552 13.9991 23.52 14.0418 23.4987 14.0844C23.4774 14.1271 23.4667 14.1804 23.4667 14.2231V23.1938C23.488 23.2151 24.2134 29.5404 24.2134 29.5404Z"
        fill="white"
        fillOpacity="0.87"
      />
    </svg>
  );
  return <>{status ? greenCircleIcon : redCircleIcon}</>;
};

export default CircleStatusIcon;
